import { Currency } from './types';

export const API_URL = import.meta.env.VITE_API_BASE_URL;
export const DEFAULT_CURRENCY: Currency = 'USD';

export const TERMS_AND_CONDITIONS_URL: string =
  'https://www.goloot.io/eng/po-terms';

// Offer/campaign/creative dates are stored as UTC but represent a fixed
// business timezone. Pin all date display to it so times don't shift with the
// viewer's browser location.
export const DISPLAY_TIME_ZONE = 'America/Toronto';

export const DEFAULT_DATE_FIELD_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  timeZone: DISPLAY_TIME_ZONE,
};
